import { useState, useEffect } from 'react';

/*
interface HideAction {
  name: string;
  permission: string;
  onlyValid: boolean;
}
*/

function useHideActions(actionList) {
  const [permission, setPermission] = useState(0);
  const [isValid, setIsValid] = useState(false);
  const [hideActions, setHideActions] = useState(false);

  useEffect(() => {
    let permittedActions = actionList.filter(action => action.permission <= permission);
    if (!isValid) {
      permittedActions = permittedActions.filter(action => !action.onlyValid)
    }
    const permittedNames = permittedActions.map(action => action.name);
    const hiddenActions = actionList
      .filter(action => !permittedNames.includes(action.name))
      .map(action => action.name);

    setHideActions(hiddenActions);
  }, [isValid, permission]);

  useEffect(() => {
  }, [hideActions])

  return [ hideActions, setIsValid, setPermission ];
}

export default useHideActions;
export { useHideActions };